import React, { Component } from "react";
import {Button, Row, Col, Modal} from 'react-bootstrap'
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

export default class AssignForm extends Component { 
  constructor(props){
    super(props)
   this.state= {
    selectedregionName:[],
    selectedcenterName:[],
    selectedclientName:[],
    selectedprocessName:[],
    selectedTemplate:[],
    showModal:false,
    isExisting:props.isExisting

  }
  this.bulkclientName =[]
}
componentDidMount(){
  this.props.action.TokenValidation()  
  this.props.action.actioninventoryUserMapped()
  this.props.action.formNames()
}
componentWillMount = () => {  
  // const{inventory} = this.props;
  // if(!_.isEmpty(inventory)){      
  //   let regionNames = _.filter(inventory);
  //    this.setState({selectedregionName:regionNames[0]})
  //   }   
}

componentWillReceiveProps(nextProps){
  if(this.state.mapTemplate === true && nextProps.mapCheck === true){
    this.checkFunction(nextProps.isExisting)
  }  
  if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
    nextProps.action.actioninventoryUserMapped()
    nextProps.action.formNames()      
  }  
}

regionNames = (prop) => {
  const{inventory} = this.props;
  if(!_.isEmpty(inventory)){
  let regionNames = _.filter(inventory); 
  return regionNames;
  }
  
}
centerNames = () => {
  const{selectedregionName} = this.state;
  const{inventory} = this.props;
  if(!_.isEmpty(inventory)){
  //_.map(selectedregionName, (obj)=>{
      let centerName = _.filter(selectedregionName.userCenters);
     // centerName.push(...x );
 // })   
    return centerName;
  }
}
clientNames = () =>{
  const{selectedcenterName} = this.state;
  const{inventory} = this.props;
  let clientName=[];
  if(!_.isEmpty(inventory)){
  _.map(selectedcenterName, (obj)=>{
      let x = _.filter(obj.userClients);
      clientName.push(...x );
      this.bulkclientName=clientName
  }) 
  return _.uniqBy(clientName, 'inventoryClientId');
  }
}
processNames = () => {
  const{selectedclientName} = this.state;
  const{inventory} = this.props;
  let processName=[];
  if(!_.isEmpty(inventory)){
  _.map(selectedclientName, (obj)=>{
     let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
    _.map(abc, (z) => {
      processName.push(...z.userProcesses)
      processName = _.uniqBy(processName, 'inventoryProcessId');
    }) 
  })
  }
  return processName;
}


handleSelect = (e) => {
  this.setState({selectedregionName: e});
  if(!_.isEqual(this.state.selectedregionName, e)){
    this.setState({selectedclientName:[], selectedprocessName:[], selectedcenterName:[]}) 
   }
}
handleSelectCenter = (e) => {
  this.setState({selectedcenterName: e});
  if(!_.isEqual(this.state.selectedcenterName, e)){
   this.setState({selectedclientName:[], selectedprocessName:[]}) 
  }
}
handleSelectClient = (e) => {
  this.setState({selectedclientName: e});
  if(!_.isEqual(this.state.selectedclientName, e)){
    this.setState({selectedprocessName:[]}) 
  }
}
handleSelectProcess = (e) => {
  this.setState({selectedprocessName: e});
}
handleSelectTemplate = (e) => {
  this.setState({selectedTemplate: e});
}
validateForm = () =>{
  const {selectedclientName,selectedprocessName,selectedcenterName,
    selectedTemplate} = this.state;
    if(selectedcenterName.length > 0 && selectedclientName.length > 0 && selectedprocessName.length > 0 && !_.isNull(selectedTemplate)){
      return true }
}
mapTemplate = () => {
  const {selectedclientName,selectedprocessName,selectedcenterName,selectedregionName,
    selectedTemplate} = this.state;  
  let centers = _.map(selectedcenterName, (cx) => { 
      let clients = [] ; let process = [];
      if(!_.isEmpty(cx.userClients)){
        _.map(selectedclientName, (obj) =>{
           _.map(cx.userClients, val =>{
            if(_.isEqual(val.inventoryClientId, obj.inventoryClientId)){
              if(!_.isEmpty(val.userProcesses)){
                _.map(selectedprocessName, (object) => {
                  let data = _.filter(val.userProcesses, object)
                  process.push(...data)
                })           
              } 
              clients.push(
                {'clientId':obj.inventoryClientId, 'clientName':obj.inventoryClientName, 'process':process}
                )
            }
            process = [];
          }) 
        })
      }
      return(
      {'centerId':cx.inventoryCenterId, 'centerName':cx.inventoryCenterName, 'clients':clients}
    )})
  // let regions = {'id':selectedregionName.inventoryRegionId, 'label':selectedregionName.inventoryRegionName}
  // let centers = _.map(selectedcenterName, (cx) => { return({'id':cx.inventoryCenterId, 'label':cx.inventoryCenterName})})
  // let clients = _.map(selectedclientName, (cx) => { return({'id':cx.inventoryClientId, 'label':cx.inventoryClientName})})
  // let process = _.map(selectedprocessName, (cx) => { return({'id':cx.inventoryProcessId, 'label':cx.inventoryProcessName})})
  let object = {
    "region" : {'id':selectedregionName.inventoryRegionId, 'label':selectedregionName.inventoryRegionName},
    "center" : centers,
    'title' : selectedTemplate.name
  } 
  this.props.action.TokenValidation()  
  this.props.action.isExistingCheck(object)
  this.setState({mapTemplate:true})  
  
}
checkFunction = (props) =>{
 if(props === true){
  this.setState({showModal:true})
 } else {
  this.setState({showModal:false})
  this.finalMapping()
 }
}
finalExisting = () => { 
  return(
  <Modal show={this.state.showModal}
  onHide={this.onClose}
  dialogClassName="modal-90w shadowClass"
  size='sm'
  aria-labelledby="contained-modal-title-vcenter"
  centered>          
  <Modal.Header closeButton><h5>Confirm</h5></Modal.Header>
  <Modal.Body>
   <h6>This web form has been already mapped. you want to replace it ?</h6>
  </Modal.Body>
  <Modal.Footer>
    <Button onClick={this.finalMapping}> OK </Button>
    <Button onClick={this.onClose}> Cancel </Button>
  </Modal.Footer>
  </Modal>)
    
} 
 onClose = () =>{
    this.setState({showModal:false})
    this.props.action.resetMapCheck()
  }
 finalMapping = () => {
    const {selectedclientName,selectedprocessName,selectedcenterName,selectedregionName,
      selectedTemplate} = this.state;
    let regions = {'id':selectedregionName.inventoryRegionId, 'label':selectedregionName.inventoryRegionName}
    let centers = _.map(selectedcenterName, (cx) => { return({'id':cx.inventoryCenterId, 'label':cx.inventoryCenterName})})
    let clients = _.map(selectedclientName, (cx) => { return({'id':cx.inventoryClientId, 'label':cx.inventoryClientName})})
    let process = _.map(selectedprocessName, (cx) => { return({'id':cx.inventoryProcessId, 'label':cx.inventoryProcessName})})
    let object = {
      "region" : regions,
      "center" : centers,
      "client" : clients,
      "process" : process,
      'title' : selectedTemplate.name
    } 
    this.props.action.TokenValidation()  
    this.props.action.mapTemplate(object)    
    this.setState({selectedregionName:[], selectedcenterName:[],
      selectedclientName:[], selectedprocessName:[], selectedTemplate:[], showModal:false})      
 }
 render(){
   return(<div className='margingap'>
   <Row>
     <Col>
       <label>Region Name</label>
     </Col>
     <Col>
      <Picky keepOpen={false}
       value={this.state.selectedregionName}
       options={this.regionNames()}
       onChange={this.handleSelect}
       open={false}
       valueKey="inventoryRegionName"
       labelKey="inventoryRegionName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
            clearFilterOnClose={true}
       placeholder='Select Region'
       dropdownHeight={600}
     /> 
     </Col>
   </Row> 
   <Row>
     <Col>
       <label>Center Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedcenterName}
       options={this.centerNames()}
       onChange={this.handleSelectCenter}
       open={false}
       valueKey="inventoryCenterName"
       labelKey="inventoryCenterName"
       multiple={true}
       includeSelectAll={true}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Center'
       dropdownHeight={600}
     /> 
     </Col>             
   </Row>
   <Row>
   <Col>
   <label>Client Name</label>
   </Col>
   <Col>
    <Picky keepOpen={false}
     value={this.state.selectedclientName}
     options={this.clientNames()}
     onChange={this.handleSelectClient}
     open={false}
     valueKey="inventoryClientName"
     labelKey="inventoryClientName"
     multiple={true}
     includeSelectAll={true}
     includeFilter={true}
            clearFilterOnClose={true}
     placeholder='Select Client'
     dropdownHeight={600}
   /> 
   </Col>
   </Row> 
   <Row>
   <Col>
   <label>Process Name</label>
   </Col>
   <Col>
   <Picky keepOpen={false}
     value={this.state.selectedprocessName}
     options={this.processNames()}
     onChange={this.handleSelectProcess}
     open={false}
     valueKey="inventoryProcessName"
     labelKey="inventoryProcessName"
     multiple={true}
     includeSelectAll={true}
     includeFilter={true}
            clearFilterOnClose={true}
     placeholder='Select Process Name'
     dropdownHeight={600}
   /> 
    </Col>
    </Row>

    <Row>
   <Col>
   <label>Web Forms</label>
   </Col>
   <Col>
   <Picky keepOpen={false}
     value={this.state.selectedTemplate}
     options={!_.isEmpty(this.props.webFormNames) ? this.props.webFormNames : []}
     onChange={this.handleSelectTemplate}
     open={false}
     valueKey="name"
     labelKey="name"
     multiple={false}
     includeSelectAll={false}
     includeFilter={true}
            clearFilterOnClose={true}
     placeholder='Select Web Form'
     dropdownHeight={600}
   />
    </Col>
    </Row>    
     <br/>
     <Button onClick={this.mapTemplate} className='buttonwidth'
     size='md' disabled={!this.validateForm()}block>MAP</Button>
    {(this.state.showModal === true &&  this.props.isExisting === true) ? this.finalExisting() : null } 
</div>)
 }
}    

